module.exports = __webpack_public_path__ + "img/ho.e1b4de09.png";